import { Input, Modal, Select } from "antd";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";

import { Button } from "@components/Button";
import { EditorAudio } from "@components/EditorComponents/EditorAudio";
import { EditorImage } from "@components/EditorComponents/EditorImage";
import { EditorRunningText } from "@components/EditorComponents/EditorRunningText";
import { EditorStreaming } from "@components/EditorComponents/EditorStreaming";
import { EditorVideo } from "@components/EditorComponents/EditorVideo";
import { EditorWebsite } from "@components/EditorComponents/EditorWebsite";
import { EditorYoutubeLive } from "@components/EditorComponents/EditorYoutubeLive";
import { ImportAudio } from "@components/ImportComponents/ImportAudio";
import { ImportImage } from "@components/ImportComponents/ImportImage";
import { ImportVideo } from "@components/ImportComponents/ImportVideo";
import { Text } from "@components/Text";
import { FormMultipleUpload } from "@pages/MediaListPage/FormMultipleUpload";
import { FormUpload } from "@pages/MediaListPage/FormUpload";
import {
  COLOR_GREEN,
  COLOR_GREY,
  COLOR_GREY_1,
  COLOR_WHITE,
} from "@static/COLORS";
import { CONTENTS_ATTRIBUTE_ANOTHER } from "@static/CONTENTS_ATTRIBUTE_ANOTHER";
import { DEFAULT_DURATION } from "@static/DEFAULT_DURATION";
import { MODAL_SIZE } from "@static/SIZE";
import { getAuthUserProfile } from "@utils/getAuthUserProfile";

const { REACT_APP_API_ENDPOINT } = process.env;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 2px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-bottom: 8px;
  background-color: rgba(0, 0, 0, 0.1);
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  gap: 16px;
  overflow: hidden;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 40px;
`;

const ContainerContents = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  /* gap: 16px; */
  height: calc(100% - 56px);
  border: 1px solid ${COLOR_GREY};
  box-sizing: border-box;
  border-radius: 8px;
  padding: 8px;
`;

const SectionAddMedia = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin-bottom: 8px;
`;

const SectionMediaList = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
  gap: 5px;
`;

const MediaBlockItem = styled.div`
  flex: 0 0 calc((100% / 6) - (5px * 5 / 6));
  height: 150px;
  flex-shrink: 0;
  flex-grow: 0;
  box-sizing: border-box;
  cursor: pointer;
`;

const SectionUploadMedia = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
`;

export const ManageWidgetImage = ({
  widgetIndex,
  setIsModalVisible,
  onHandleUpdateWidgetImage,
}) => {
  const location = useLocation();
  const authUserProfile = getAuthUserProfile();
  const customerId = _.get(location, ["state", "customerId"]);
  const locationId = _.get(location, ["state", "locationId"]);
  const [isCloseModal, setIsCloseModal] = useState(true);

  const [widgetImageAttribute, setWidgetImageAttribute] = useState(null);

  const [isOpenModal, setIsOpenModal] = useState({
    isOpen: false,
    modalType: null,
  });

  // all image form database where location_id
  const mediaList = useSelector(({ mediaList }) => {
    return _.get(mediaList, ["data", "image"]);
  });

  console.log("mediaList :>> ", mediaList);

  const handleSelectImage = ({ path, id }) => {
    const updateImageWidget = {
      media_id: id,
      is_use_media_in_project: true,
      attribute: { path },
    };
    setWidgetImageAttribute(updateImageWidget);
  };

  const onHandleConfirm = () => {
    onHandleUpdateWidgetImage({
      index: widgetIndex,
      updateData: widgetImageAttribute,
    });
    setIsModalVisible((prev) => ({ ...prev, isOpen: false }));
  };

  return (
    <Container>
      <Line />
      <InnerContainer>
        <ContainerContents>
          <SectionAddMedia>
            <SectionUploadMedia>
              <Button
                onClick={() =>
                  setIsOpenModal({ isOpen: true, modalType: "multiple upload" })
                }
                color={COLOR_GREEN}
                fontColor={COLOR_WHITE}
                padding="7px 15px"
              >
                Add Multiple Media
              </Button>
              <Button
                onClick={() =>
                  setIsOpenModal({ isOpen: true, modalType: "upload" })
                }
                color={COLOR_GREEN}
                fontColor={COLOR_WHITE}
                padding="7px 15px"
              >
                Add Media
              </Button>
            </SectionUploadMedia>
          </SectionAddMedia>
          <SectionMediaList>
            {_.map(mediaList, (item, index) => {
              console.log("item :>> ", item);
              const path = _.get(item, ["path"]);
              const fullPath = `${REACT_APP_API_ENDPOINT}/${path}`;
              console.log("fullPath :>> ", fullPath);
              return (
                <MediaBlockItem
                  key={index}
                  onClick={() => handleSelectImage({ path, id: item?.id })}
                >
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                    src={fullPath}
                    alt={"get-led"}
                  />
                </MediaBlockItem>
              );
            })}
          </SectionMediaList>
        </ContainerContents>
        <ButtonContainer>
          <Button
            disabled={_.isNil(widgetImageAttribute)}
            onClick={() => onHandleConfirm()}
            color={COLOR_GREEN}
            fontColor={COLOR_WHITE}
            fontSize="16px"
            padding="5px 20px"
          >
            Confirm
          </Button>
        </ButtonContainer>
      </InnerContainer>
      <Modal
        width={MODAL_SIZE}
        destroyOnClose={true}
        title={`Upload Media`}
        open={_.get(isOpenModal, ["isOpen"])}
        footer={null}
        // onCancel={() => setIsOpenModal((prev) => ({ ...prev, isOpen: false }))}
        onCancel={() => {
          if (isCloseModal) {
            setIsOpenModal((prev) => ({ ...prev, isOpen: false }));
          }
        }}
      >
        {_.get(isOpenModal, ["modalType"]) === "upload" && (
          <FormUpload
            setIsCloseModal={setIsCloseModal}
            useInManageBlock={true}
            mediaList={mediaList}
            userProfile={authUserProfile}
            location_id={locationId}
            customer_id={customerId}
            setIsModalVisible={setIsOpenModal}
            dataList={[]}
          />
        )}

        {_.get(isOpenModal, ["modalType"]) === "multiple upload" && (
          <FormMultipleUpload
            setIsCloseModal={setIsCloseModal}
            useInManageBlock={true}
            mediaList={mediaList}
            customer_id={customerId}
            location_id={locationId}
            setIsModalVisible={setIsOpenModal}
            dataList={[]}
          />
        )}
      </Modal>
    </Container>
  );
};
